/*
 * @Author: GRANDSOFT\chenz-k chenz-k@glodon.com
 * @Date: 2022-10-25 15:13:08
 * @LastEditors: GRANDSOFT\chenz-k chenz-k@glodon.com
 * @LastEditTime: 2022-10-25 15:14:29
 * @FilePath: \shared-portal-web\packages\login\src\utils\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from 'axios'

// import { encode } from 'querystring'

// 创建axios实例
const instance = axios.create({
  timeout: 1000 * 12,
  withCredentials: false // Check cross-site Access-Control
})
// 设置post请求头
// instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  config => {
    // if (config.method === 'post') {
    //   config.data = encode(config.data)
    // }
    return config
  },
  error => Promise.error(error))

// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  res => res.status === 200 ? Promise.resolve(res.data) : Promise.reject(res),
  // 请求失败
  error => {
    const { response } = error
    if (response) {
      return Promise.reject(response)
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      if (!window.navigator.onLine) {
      } else {
        return Promise.reject(error)
      }
    }
  })

export default instance
